import { useEffect, useContext, useState } from 'react';
import { CancelFlightByRecordLocator, CancelFlightResponse} from '@tff/types/tff/cancel-flight-service';
import { LoadingContext } from '../contexts/LoadingContextProvider';
import { apigeeEndpoint } from '../apis';

export type TypeOfStatus = 'IN_CANCELLATION' | 'CANCELLED' | 'FAILURE';

export type CancelBookingProps = {
  recordLocator?: string;
  cancelFlightRequest?: CancelFlightByRecordLocator;
};

export type CancelBookingResponse = {
  cancelledBooking?: CancelFlightResponse;
  cancelBookingStatus?: TypeOfStatus;
  cancelBookingError?: any;
};

//
export const useCancelBooking = (cancelBookingProps: CancelBookingProps): CancelBookingResponse => {
  const [cancelBookingStatus, setCancelBookingStatus] = useState<TypeOfStatus>();
  const [cancelledBooking, setCancelledBooking] = useState<CancelFlightResponse>();
  const [cancelBookingError, setCancelBookingError] = useState<Error | undefined>();
  const { showLoading, closeLoading } = useContext(LoadingContext);

  useEffect(() => {
    const cancelBookingAtBackend = async (cancelRequest: CancelFlightByRecordLocator): Promise<void> => {
      try {
        setCancelBookingStatus('IN_CANCELLATION');
        showLoading(`Cancel ${cancelRequest.bookingSource} Booking`);
        const response = await apigeeEndpoint.post(`/cancel/${cancelRequest.bookingSource}`, cancelRequest);

        if (response.data.status === 'FAILURE') {
          let errorMsg = response.data.error;
          if (Array.isArray(errorMsg)) {
            errorMsg = errorMsg.map(e => e.StatusText).join(', ');
          }
          setCancelBookingError(errorMsg);
          setCancelBookingStatus('FAILURE');
        }
        if (response.data.status === 'SUCCESS') {
          setCancelBookingStatus('CANCELLED');
        }

        setCancelledBooking(response.data.data ?? response.data);
      } catch (error) {
        setCancelBookingError(error);
        setCancelBookingStatus('FAILURE');
      } finally {
        closeLoading();
      }
    };

    if (cancelBookingProps?.cancelFlightRequest && !cancelBookingStatus) {
      void cancelBookingAtBackend(cancelBookingProps.cancelFlightRequest);
    }
  }, [cancelBookingProps]);

  return { cancelBookingError, cancelledBooking, cancelBookingStatus };
};
